import { CANDIDATE_SOURCE_LABELS } from "@/types/screeners";

interface CandidateSourceBadgeProps {
  source: string;
}

/**
 * Badge component for displaying candidate source type.
 * Uses consistent styling and label lookup.
 */
export const CandidateSourceBadge = ({ source }: CandidateSourceBadgeProps) => {
  return (
    <span className="inline-flex items-center rounded-md bg-gray-100 px-2 py-1 text-xs font-medium text-gray-600">
      {CANDIDATE_SOURCE_LABELS[source] || source}
    </span>
  );
};
